/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditableText from 'material/embeds/editabletext/editabletext_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/storytitle/storytitle_styles';



/* ========== ~~~~~~~~~~ EMBED : STORYTITLE ~~~~~~~~~~ ========== */
class StoryTitle extends Component {
    constructor(props) {
        super(props);
        this.prevCharAmount = 0;
        this.characterLimit = 150;
        this.state = { fontSize: 'standard' };
    }
    componentDidMount() {
        // this.validateText(this.props.contentTitle, getElementCSSProperty(document.querySelector('.embededitor .question .text'), 'height'));
        this.validateText({ text: this.props.contentTitle, initialValidation: true });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentId !== this.props.contentId) this.validateText({ text: this.props.contentTitle, initialValidation: true });
    }
    adjustFontSize = text => {
        const charAmount = text !== null ? text.length: '';
        let fontSize = 'standard';
        if ((charAmount >= 50) && (charAmount < 78)) { fontSize = 'medium'; }
        if ((charAmount >= 78) && (charAmount < 104)) { fontSize = 'small'; }
        if ((charAmount >= 104) && (charAmount < 128)) { fontSize = 'xsmall'; }
        if ((charAmount >= 128) && (charAmount < 152)) { fontSize = 'xxsmall'; }
        if (charAmount >= 152) { fontSize = 'xxxsmall'; }

        if (this.state.fontSize !== fontSize) this.setState({ fontSize })
    };
    runValidation = text => this.validateText({ text, initialValidation: false });

    validateText = ({ text, initialValidation }) => {
        const trimmedText = text !== null ? text.trim() : '';
        const isValid = this.props.isValid;
        if(trimmedText.length > this.characterLimit || (initialValidation && isValid === null)) return null;
        this.adjustFontSize(trimmedText);
        if (trimmedText.length > 0 && !isValid) {
            this.props.setStoryProperty(this.props.contentId, 'isTitleValid', true)
        } else if ((trimmedText.length === 0 || trimmedText.length > this.characterLimit) && (isValid || isValid === null)) {
            this.props.setStoryProperty(this.props.contentId, 'isTitleValid', false)
        }
    };
    handleSelect = () => {
        if(!this.props.isValid) this.props.setStoryProperty(this.props.contentId, 'isTitleValid', null)
    };
    render() {
        const placeholderText = 'Type your headline here';
        return(
            <div className={`storytitle ${this.props.classes.storytitle} valid-${this.props.isValid}`}>
                <h3 className={`text ${this.state.fontSize} ${this.props.embedLocationType}`} >
                    <EditableText
                        key={`${this.props.isEditable ? `editor` : `card`}-story-${this.props.contentId}${this.props.optionId}`}
                        contentId={this.props.contentId}
                        textValue={this.props.contentTitle}
                        textType={'storyTitle'}
                        isEditable={this.props.isEditable}
                        isOption={false}
                        optionId={null}
                        placeholder={placeholderText}
                        onKeyUp={this.runValidation}
                        onBlur={this.runValidation}
                        onFocus={this.runValidation}
                        isSelected={true}
                        preventEnter={true}
                        characterLimit={this.characterLimit}
                        validateText={this.runValidation}
                    />
                </h3>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StoryTitle);
